<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Utilisateurs</span>
        <h3 v-if="this.$route.name === 'edit-user'"  class="page-title">Edition Utilisateur</h3>
        <h3 v-else class="page-title">Ajout Utilisateur</h3>
      </div>
    </div>

    <d-row>
      <d-col lg="10" xl="9" class="mx-auto mt-1">
        <d-card class="card-small edit-user-details mb-4">
          <d-card-header class="p-0">

            <!-- User Details - Background -->
            <div class="edit-user-details__bg">
              <img src="@/assets/images/user-profile/up-user-details-background.jpg"
                   alt="User Details Background Image">
            </div>

          </d-card-header>
          <d-card-body class="p-0">

            <!-- Nav Wrapper -->
            <div class="border-bottom clearfix">
              <div class="border-0 mt-auto mx-4 pt-2">

                <d-tabs content-class="mt-3 tab-choice">

                  <d-tab title="Général" active>

                    <d-form class="py-4">
                      <d-form-row class="mx-4">
                        <d-col class="mb-3">
                          <d-form-text tag="h6" class="m-0">{{ $t('user.add.edit.first.group.title') }}</d-form-text>
                        </d-col>
                      </d-form-row>
                      <d-form-row class="mx-4">
                        <d-col lg="8">
                          <d-form-row>

                            <d-col md="12" class="form-group">
                              <label for="firstName">{{ $t('user.add.edit.structure') }}</label>
                              <sorted-select :model="model" name="structureReference" :firstOption="$t('user.add.edit.structure.list')" :listOptions="structuresList" value="reference" title="name"></sorted-select>
                              <errors :errors="errors" field="structureReference"/>
                            </d-col>

                            <!-- First Name -->
                            <d-col md="6" class="form-group">
                              <label for="firstName">{{ $t('user.firstname') }}</label>
                              <d-input type="text" id="firstName" v-model="model.firstName" :state="errors['firstName'] === undefined ? null : false"/>
                              <errors :errors="errors" field="firstName"/>
                            </d-col>

                            <!-- Last Name -->
                            <d-col md="6" class="form-group">
                              <label for="lastName">{{ $t('user.lastname') }}</label>
                              <d-input type="text" id="lastName" v-model="model.lastName" :state="errors['lastName'] === undefined ? null : false"/>
                              <errors :errors="errors" field="lastName"/>
                            </d-col>

                            <!-- Email Address -->
                            <d-col md="6" class="form-group">
                              <label for="emailAddress">{{ $t('user.email') }}</label>
                              <d-input-group seamless>
                                <d-input-group-text slot="prepend">
                                  <i class="material-icons">&#xE0BE;</i>
                                </d-input-group-text>
                                <d-input id="emailAddress" type="email" v-model="model.email" :state="errors['email'] === undefined ? null : false"/>
                              </d-input-group>
                              <errors :errors="errors" field="email"/>
                            </d-col>

                            <!-- Phone Number -->
                            <d-col md="6" class="form-group">
                              <label for="phoneNumber">{{ $t('user.phone') }}</label>
                              <d-input-group seamless>
                                <d-input-group-text slot="prepend">
                                  <i class="material-icons">&#xE0CD;</i>
                                </d-input-group-text>
                                <d-input id="phoneNumber" v-model="model.phone"/>
                              </d-input-group>
                            </d-col>

                          </d-form-row>
                        </d-col>


                      </d-form-row>

                      <d-form-row class="mx-4">

                        <!-- User Address -->
                        <d-col md="6" class="form-group">
                          <label for="userAddress">{{ $t('user.address') }}</label>
                          <textarea v-model="model.address" name="userAddress" id="userAddress" wrap="soft" class="form-control" style="min-height: 87px;" ></textarea>
                        </d-col>

                      </d-form-row>

                      <hr/>

                      <!-- Change Password -->
                      <d-form-row class="mx-4">
                        <d-col class="mb-4">
                          <d-form-text tag="h6" class="m-0">{{ $t('user.password') }}</d-form-text>
                          <d-form-text v-if="!edit" tag="p" class="text-muted m-0">{{ $t('user.add.edit.subtitle.password') }}
                          </d-form-text>
                        </d-col>
                      </d-form-row>

                      <d-form-row class="mx-4">
                        <d-col class="d-flex">
                          <p v-if="!edit">{{ $t('user.add.password.want.to.define') }}</p>
                          <p v-else> {{ $t('user.edit.password.want.to.define') }}</p>
                          <d-checkbox class="ml-auto my-auto" v-model="customPassword" toggle/>
                        </d-col>
                      </d-form-row>


                      <d-form-row class="mx-4" v-if="customPassword">
                        <!-- New Password -->
                        <d-col md="4" class="form-group">
                          <label for="newPassword">{{ $t('user.password') }}</label>
                          <d-input id="newPassword" :placeholder="$t('user.password')" v-model="model.password" :state="errors['password'] === undefined ? null : false"/>
                          <errors :errors="errors" field="password"/>
                        </d-col>

                        <!-- Repeat New Password -->
                        <d-col md="4" class="form-group">
                          <label for="repeatNewPassword">{{ $t('user.form.confirm.password') }}</label>
                          <d-input id="repeatNewPassword" type="password" :placeholder="$t('user.password')" v-model="verifyPassword" :state="errors['password'] === undefined ? null : false"/>
                        </d-col>

                      </d-form-row>
                    </d-form>
                  </d-tab>


                  <d-tab title="Groupes, Permissions, Congé">
                    <d-form class="py-4">
                      <d-form-row class="mx-4">
                        <d-col class="mb-3">
                          <d-form-text tag="h6" class="m-0">{{ $t('user.day.off') }}</d-form-text>
                        </d-col>
                      </d-form-row>
                      <d-form-row class="mx-4">
                        <d-col class="mb-3">
                          <select class="form-control" v-model="model.information['dayOff']">
                            <option :value="undefined">A définir</option>
                            <option value="1">Lundi</option>
                            <option value="2">Mardi</option>
                            <option value="3">Mercredi</option>
                            <option value="4">Jeudi</option>
                            <option value="5">Vendredi</option>
                            <option value="6">Samedi</option>
                            <option value="0">Dimanche</option>
                          </select>
                        </d-col>
                      </d-form-row>

                      <d-form-row class="mx-4">
                        <d-col class="mb-3">
                          <d-form-text tag="h6" class="m-0">{{ $t('user.groups.permissions') }}</d-form-text>
                        </d-col>
                      </d-form-row>
                      <d-form-row class="mx-4">
                        <d-col lg="6">
                          <d-card class="card-small user-teams mb-4">
                            <d-card-body class="p-0">
                              <d-container fluid class="position-static">
                                <!-- Teams List -->
                                <d-row v-for="(team, idx) in teams" :key="idx" class="px-3">
                                  <d-col lg="12" sm="1" class="user-teams__image my-auto p-0">
                                    <div class="group-info" :style="{backgroundColor: team.color, color: team.txtColor ? team.txtColor : '#6f6f6f'}">{{team.name.substring(0,1)}}</div>
                                  </d-col>
                                  <d-col class="user-teams__info pl-3">
                                    <h6 class="m-0">{{ team.name }}</h6>
                                  </d-col>
                                  <d-col class="d-flex">
                                    <d-checkbox class="ml-auto my-auto" @change="selectGroup($event, team)" :checked="isGroupSelected(team.reference)" toggle/>
                                  </d-col>
                                </d-row>
                              </d-container>
                            </d-card-body>
                          </d-card>
                        </d-col>
                        <d-col lg="6">
                          <d-card class="card-small">
                            <d-card-body class="p-0" v-if="selectedGroups.length > 0">
                              <d-col v-for="(item, idx) in selectedGroupsFiltered" :key="idx" class="p-0 mt-3 mb-3">
                                <span class="ml-3">{{ item.name }}</span>
                                <hr/>
                                <d-list-group flush class="list-group-small pb-1" v-if="item.access.length > 0">
                                  <d-list-group-item v-for="(access, id) in item.access" :key="id" class="d-flex px-3">
                                    <span class="text-semibold text-fiord-blue"> {{ item.detailsAccess[access] }}</span>
                                    <d-checkbox class="ml-auto my-auto" toggle @change="selectPermission($event, item, access)" :checked="isPermissionSelected(item.reference, access)"/>
                                  </d-list-group-item>
                                </d-list-group>
                                <div v-else class="pb-1">
                                  <span class="ml-3 text-semibold text-fiord-blue">{{ $t('user.add.edit.no.permission') }}</span>
                                </div>
                              </d-col>

                            </d-card-body>
                          </d-card>
                        </d-col>
                      </d-form-row>
                    </d-form>
                  </d-tab>

                  <d-tab title="Responsables">
                    <d-form class="py-4">
                        <d-form-row class="mx-4">
                          <d-col class="mb-3">
                            <d-form-text tag="h6" class="m-0">{{ $t('user.add.edit.in.charge') }}</d-form-text>
                          </d-col>
                        </d-form-row>
                        <d-form-row class="mx-4">
                          <in-charge-selector ref="inChargeSelector" @updateInCharge="updateInCharge" :exclude-reference="reference" />
                        </d-form-row>
                    </d-form>
                  </d-tab>
                </d-tabs>
              </div>

            </div>

          </d-card-body>

          <!-- Save Changes -->
          <d-card-footer class="border-top">

  <d-div class="d-flex justify-content-around">
                <div class="col">
         <d-button size="sm" v-if="this.$route.name === 'edit-user'" class="btn-danger  d-table" @click="deleteUser">
              {{$t('global.Delete')}}
             </d-button>
                </div>
                <div class="col">
          <d-button size="sm" class="btn-accent float-right  d-table" @click="saveUser">
              {{ $t('global.save') }}
            </d-button>

                </div>
            </d-div>


          </d-card-footer>

        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import groups from '@/data/groups/Groups';
import { checkIfCanEditUser, canSeeIt } from '../../utils/Rules.js';
import Errors from '../../components/error/errors.vue';
import ErrorsHelper from '../../helper/ErrorsHelper';
import SortedSelect from '../../components/form/SortedSelect.vue';
import InChargeSelector from '../../components/user/inCharge/InChargeSelector.vue';

export default {
  components: { InChargeSelector, SortedSelect, Errors },
  data() {
    return {
      selectedGroups: [],
      model: { information: {} },
      verifyPassword: undefined,
      requiredFields: ['email', 'firstName', 'lastName', 'structureReference'],
      errors: {},
      reference: null,
      customPassword: false,
      edit: false,
    };
  },
  computed: {
    structuresList() {
      return this.$store.state.structure.list;
    },
    teams() {
      return groups.filter(group => group.visible && canSeeIt(group.permissionsToSet, this.$store.state.user.informations.permissions));
    },
    selectedGroupsFiltered() {
      return this.selectedGroups.filter(group => this.teams.find(g => g.reference === group.reference));
    },
  },
  mounted() {
    if (this.$route.name === 'edit-user') {
      this.edit = true;
      this.reference = this.$route.params.reference;
      this.$services.user.findByReference(this.reference)
        .then(({ data }) => {
          this.model = data;
          if (!checkIfCanEditUser(this.$store.state.user.informations, this.model)) {
            this.$router.push('/permission-denied');
          }
          this.updateGroupsAndPermissions();
          this.$refs.inChargeSelector.setInCharge(this.model.inCharge);
        });
    }
  },
  methods: {
    saveUser() {
      this.errors = {};
      if (ErrorsHelper.checkErrors(this.requiredFields, this.model, this.errors)) {
        this.model.email = this.model.email.toLowerCase();
        if (this.customPassword && this.model.password !== this.verifyPassword) {
          ErrorsHelper.addError(this.errors, 'password', this.$t('user.form.password.mismatch'));
          return;
        }
        this.setGroupsAndPermissions();
        if (this.reference === null) {
          this.$services.user.create(this.model).then(() => {
            this.$router.push('/liste-utilisateurs');
            this.$miniToastr.success(this.$t('user.add.success'));
          });
        } else {
          this.$services.user.update(this.model).then(() => {
            this.$router.push('/liste-utilisateurs');
            this.$miniToastr.success(this.$t('user.edit.success'));
          });
        }
      }
    },
    deleteUser() {
      this.$confirmModal.show({
        text: `${this.$t('user.delete.confirm')}`,
        onConfirm: () => {
          this.$services.user.deleteUser(this.reference).then(() => {
            this.$router.push('/liste-utilisateurs');
            this.$miniToastr.success(this.$t('user.edit.success'));
          });
        },
      });
    },
    setGroupsAndPermissions() {
      const permissions = [];
      this.selectedGroups.forEach((group) => {
        const permission = {
          groupReference: group.reference,
          access: group.selectedAccess,
        };
        permissions.push(permission);
      });
      this.model.permissions = permissions;
    },
    selectGroup(value, team) {
      const group = {
        name: team.name, reference: team.reference, access: team.access, selectedAccess: [], detailsAccess: team.detailsAccess,
      };
      if (value) {
        this.selectedGroups.push(group);
      } else {
        const index = this.selectedGroups.findIndex(g => g.reference === team.reference);
        this.selectedGroups.splice(index, 1);
      }
    },
    selectPermission(value, team, access) {
      const index = this.selectedGroups.findIndex(group => group.reference === team.reference);
      if (value) {
        this.selectedGroups[index].selectedAccess.push(access);
      } else {
        const accessIndex = this.selectedGroups[index].selectedAccess.indexOf(access);
        this.selectedGroups[index].selectedAccess.splice(accessIndex, 1);
      }
    },
    updateGroupsAndPermissions() {
      this.model.permissions.forEach((permission) => {
        const team = groups.find(t => t.reference === permission.groupReference);
        if (team) {
          const selectedGroup = {
            name: team.name, reference: team.reference, access: team.access, detailsAccess: team.detailsAccess,
          };
          selectedGroup.selectedAccess = permission.access;
          this.selectedGroups.push(selectedGroup);
        }
      });
    },
    isGroupSelected(reference) {
      if (this.selectedGroups.length === 0) return false;
      return this.selectedGroups.find(permission => permission.reference === reference) !== undefined;
    },
    isPermissionSelected(groupReference, access) {
      const group = this.selectedGroups.find(permission => permission.reference === groupReference);
      if (group.selectedAccess) {
        return group.selectedAccess.indexOf(access) > -1;
      }
      return false;
    },
    updateInCharge(inCharge) {
      this.model.inCharge = inCharge;
    },
  },
};
</script>

<style>
  .group-info {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 23px;
    font-weight: 700;
    border-radius: 10px;
  }

  .nav-tabs:focus {
    outline: none !important;
  }

  .user-teams .card-body {
    min-height: unset !important;
  }
</style>
